export type Url =
	| 'about'
	| 'fun-facts'
	| 'experience'
	| 'projects'
	| 'education'
	| 'media'
	| 'contact'

export enum UrlOption {
	About = 'about',
	FunFacts = 'fun-facts',
	Experience = 'experience',
	Projects = 'projects',
	Education = 'education',
	Media = 'media',
	Contact = 'contact',
}
